import { types } from 'mobx-state-tree'
import { IdNamePair } from './collection'

export const OrderValues = types.model({
   items: types.optional(types.array(IdNamePair), []),
   totalCount: types.optional(types.number, 0),
})
